import { Link } from 'react-router-dom'
import type { TagItem } from '@/legacy/components/ui/Typography'

export type BlogGridItem = {
  title: string
  excerpt: string
  to: string
  tags: TagItem[]
  image?: {
    url: string
    alternativeText?: string
  }
}

export const BlogGrid = ({ items }: { items: BlogGridItem[] }) => (
  <div className="blog-article-grid">
    {items.map((item) => (
      <Link key={item.to} to={item.to} className="blog-article-card">
        <img src={item.image?.url ?? '/media/photos/article-components-hero.avif'} alt={item.image?.alternativeText ?? ''} loading="lazy" decoding="async" />
        <div>
          <h3>{item.title}</h3>
        </div>
      </Link>
    ))}
  </div>
)
